// package imports

import { SyncOutlined } from '@ant-design/icons';
import { useCreate, useTranslate } from '@refinedev/core';
import { Button } from 'antd';

// project imports

import openNotificationWithIcon from 'core/utils/notification';
import constants from 'core/constants/Constants';
import apiEndpoint from 'core/common/apiEndPoints';

const ErrorTable = ({
  errorData,
  isDeveloperMode,
  sourceType,
  handleModalCancel,
}) => {
  const t = useTranslate();
  const { mutate } = useCreate();
  // console.log('errorData', errorData);

  function retryHandle(sourceId) {
    // source_id and source_type
    console.log('retry api call ', sourceId, sourceType);
    mutate(
      {
        resource:
          sourceType === ''
            ? apiEndpoint.retryUnification
            : apiEndpoint.retryWorkflowTrigger,
        dataProviderName:
          sourceType === '' ? 'payoutProvider' : 'inputDataProvider',
        values:
          sourceType === ''
            ? { unification_run_master_id: sourceId }
            : { source_id: sourceId, source_type: sourceType },
        successNotification: false,
        errorNotification: false,
      },
      {
        onSuccess: (result) => {
          const message =
            result?.data?.message || t('notifications.createSuccess');
          handleModalCancel();
          openNotificationWithIcon(
            constants.success,
            t('notifications.mutationSuccess'),
            message
          );
        },
        onError(error) {
          const message = error?.message || t('notifications.createError');
          openNotificationWithIcon(
            constants.error,
            t('notifications.mutationError'),
            message
          );
        },
      }
    );
  }
  const showActionColumn =
    (errorData?.length > 0 &&
      errorData.some((item) => item?.error_stack?.is_async === true)) ||
    false;

  return (
    <table className="border border-neutral-60 my-md w-full">
      <thead className="sticky top-0 z-10">
        <tr className="bg-neutral-50 text-neutral-300 uppercase text-base leading-normal ">
          <th className="error-table-header w-1/6">
            {t('pages.errorModal.name')}
          </th>
          {isDeveloperMode ? (
            <th className="error-table-header w-1/12">
              {t('pages.errorModal.component')}
            </th>
          ) : null}
          <th className="error-table-header w-1/3">
            {/* {isDeveloperMode
              ? t('pages.errorModal.stackTrace')
              : t('pages.errorModal.error')} */}
            {t('pages.errorModal.error')}
          </th>
          {isDeveloperMode ? (
            <th className="error-table-header w-1/3">
              {t('pages.errorModal.stackTrace')}
            </th>
          ) : null}
          {showActionColumn ? (
            <th className="error-table-header w-[100px] break-all">
              {t('pages.errorModal.action')}
            </th>
          ) : null}
        </tr>
      </thead>
      <tbody className=" text-neutral-300 text-base font-light">
        {errorData?.map((item, index) => (
          <tr
            key={index}
            className="border-b border-neutral-60 bg-neutral-30 hover:bg-neutral-60"
          >
            <td
              className={`error-cellBase ${
                isDeveloperMode ? ' w-1/6' : ' w-[30%]'
              }`}
            >
              {item?.name}
            </td>
            {isDeveloperMode ? (
              <td className="error-table-header w-1/12 break-all">
                {item?.error_stack?.component}
              </td>
            ) : null}
            <td
              className={`error-cellBase ${
                isDeveloperMode ? ' w-1/3' : ' w-[60%]'
              }`}
            >
              {isDeveloperMode
                ? item?.error_stack?.error
                : item?.error_stack?.message}
            </td>
            {isDeveloperMode ? (
              <td className="error-table-header w-1/3 break-all">
                {item?.error_stack?.stack_trace}
              </td>
            ) : null}
            {showActionColumn ? (
              <td className="py-sm px-lg text-end w-[100px] break-all">
                {' '}
                {item?.error_stack?.is_async ? (
                  <Button
                    size="small"
                    className="!p-md"
                    type="primary"
                    icon={<SyncOutlined />}
                    disabled={!item?.error_stack?.is_async}
                    onClick={() => retryHandle(item?.unique_id)}
                  >
                    {t('pages.errorModal.retry')}
                  </Button>
                ) : (
                  '-'
                )}
              </td>
            ) : null}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default ErrorTable;
